var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-auto"},[_c('div',{staticClass:"mx-wd-100p",domProps:{"innerHTML":_vm._s(_vm.task.taskDesc)}})])}
var staticRenderFns = []

export { render, staticRenderFns }